import config from "../config/config";

export const initGoogleAnalytics = () => {
  const gtagId = (config as any).gtagId;
  
  if (!gtagId) {
    console.warn("Google Analytics ID not configured for this chain");
    return;
  }

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', gtagId);

  // Make gtag available globally
  (window as any).gtag = gtag;
};

